import { render } from "./App.vue?vue&type=template&id=5f331f47"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5f331f47&lang=scss"

import exportComponent from "D:\\work\\ixiayue\\qingyu-share\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__